import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { 
  FaEnvelope, 
  FaUser, 
  FaCheckCircle,
  FaNewspaper,
  FaBell,
  FaCalendarAlt,
  FaChartLine,
  FaBookOpen,
  FaArrowRight,
  FaWhatsapp,
  FaGoogle
} from 'react-icons/fa';

const PageContainer = styled.div`
  margin-top: 180px;
  min-height: calc(100vh - 140px);
  background: #ffffff;

  @media (max-width: 1366px) and (min-width: 769px) {
    margin-top: 155px;
  }


  @media (max-width: 768px) {
    margin-top: 120px;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 3rem 5%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const LeftContent = styled.div``;

const RightContent = styled.div``;

const Title = styled.h1`
  color: #1a1a2e;
  font-size: 2.5rem;
  margin-bottom: 1rem;
  
  span {
    color: #3730A3;
  }
`;

const Subtitle = styled.p`
  color: #4a4a6a;
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
`;

const FeatureList = styled.div`
  margin-top: 2rem;
`;

const FeatureItem = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

const FeatureIcon = styled.div`
  width: 50px;
  height: 50px;
  background: rgba(55, 48, 163, 0.08);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3730A3;
  font-size: 1.5rem;
  flex-shrink: 0;
`;

const FeatureContent = styled.div`
  h3 {
    color: #1a1a2e;
    font-size: 1.1rem;
    margin-bottom: 0.3rem;
  }
  
  p {
    color: #4a4a6a;
    font-size: 0.9rem;
    line-height: 1.5;
  }
`;

const FormContainer = styled.div`
  background: white;
  border-radius: 20px;
  padding: 2.5rem;
  box-shadow: 0 10px 30px rgba(55, 48, 163, 0.06);
  border: 1px solid rgba(55, 48, 163, 0.06);
`;

const FormTitle = styled.h2`
  color: #1a1a2e;
  font-size: 1.8rem;
  margin-bottom: 0.5rem;
`;

const FormSubtitle = styled.p`
  color: #4a4a6a;
  margin-bottom: 2rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
`;

const Label = styled.label`
  color: #1a1a2e;
  font-weight: 500;
  font-size: 0.9rem;
`;

const Input = styled.input`
  padding: 0.8rem 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.95rem;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #3730A3;
    box-shadow: 0 0 0 3px rgba(55, 48, 163, 0.08);
  }
`;

const CheckboxGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0.5rem 0;
`;

const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
`;

const CheckboxLabel = styled.label`
  color: #4a4a6a;
  font-size: 0.9rem;
  cursor: pointer;
`;

const SubmitButton = styled.button`
  background: #3730A3;
  color: white;
  border: none;
  padding: 1rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  &:hover {
    background: #0b0b77;
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(55, 48, 163, 0.25);
  }

  &:disabled {
    background: #cbd5e0;
    cursor: not-allowed;
    transform: none;
  }
`;

const StatusMessage = styled.div`
  margin: 1rem 0;
  padding: 0.8rem;
  border-radius: 8px;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  
  ${props => props.type === 'success' && `
    background: #e8f5e9;
    color: #2e7d32;
  `}
  
  ${props => props.type === 'error' && `
    background: #ffebee;
    color: #c62828;
  `}
  
  ${props => props.type === 'info' && `
    background: #e3f2fd;
    color: #1565c0;
  `}
`;

const SuccessMessage = styled.div`
  text-align: center;
  padding: 3rem 2rem;

  svg {
    font-size: 4rem;
    color: #4CAF50;
    margin-bottom: 1rem;
  }

  h3 {
    color: #1a1a2e;
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }

  p {
    color: #4a4a6a;
    margin-bottom: 1rem;
  }

  .success-details {
    background: #f8f7fc;
    padding: 1rem;
    border-radius: 8px;
    margin: 1.5rem 0;
    text-align: left;
    
    h4 {
      color: #1a1a2e;
      margin-bottom: 0.5rem;
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
    
    ul {
      list-style: none;
      padding: 0;
      
      li {
        margin-bottom: 0.5rem;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        color: #2e7d32;
      }
    }
  }
`;

const BackLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #3730A3;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    color: #ffd966;
    gap: 0.8rem;
  }
`;

const Signup = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    interests: [],
    agreeTerms: false
  });
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });

  const interests = [
    'Medical Coding Updates',
    'Certification Tips',
    'Career Advice',
    'Industry News',
    'Specialty Training',
    'Exam Prep'
  ];

  const GOOGLE_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSfDSiarWuxB8bpVKgRRBe-mBk5JG_cCG7DAt4ctpNRxviy6hw/formResponse';

  const FIELD_IDS = {
    name: 'entry.885494200',
    email: 'entry.1793760125',
    interests: 'entry.1746780444',
    signupDate: 'entry.676079484'
  };

  const WHATSAPP_NUMBER = '9000013099';
  const FBZX_VALUE = '-8128713703568398055';

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox' && name === 'interests') {
      if (checked) {
        setFormData({
          ...formData,
          interests: [...formData.interests, value]
        });
      } else {
        setFormData({
          ...formData,
          interests: formData.interests.filter(item => item !== value)
        });
      }
    } else if (type === 'checkbox') {
      setFormData({ ...formData, [name]: checked });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const submitToGoogleForms = async () => {
    const formDataObj = new FormData();
    
    formDataObj.append(FIELD_IDS.name, formData.name);
    formDataObj.append(FIELD_IDS.email, formData.email);
    
    const today = new Date().toLocaleDateString();
    formDataObj.append(FIELD_IDS.signupDate, today);
    
    formData.interests.forEach(interest => {
      formDataObj.append(FIELD_IDS.interests, interest);
    });
    
    formDataObj.append('fvv', '1');
    formDataObj.append('partialResponse', '[null,null,"-8128713703568398055"]');
    formDataObj.append('pageHistory', '0');
    formDataObj.append('fbzx', FBZX_VALUE);
    formDataObj.append('submissionTimestamp', Date.now().toString());
    
    try {
      await fetch(GOOGLE_FORM_URL, {
        method: 'POST',
        mode: 'no-cors',
        body: formDataObj
      });
      
      return { success: true };
    } catch (error) {
      console.error('Google Forms submission error:', error);
      return { success: false, error: error.message };
    }
  };

  const sendWhatsAppNotification = () => {
    const interestsList = formData.interests.length > 0 
      ? formData.interests.join(' • ') 
      : 'Not specified';
    
    const today = new Date().toLocaleDateString();
    
    const message = `🔔 *NEW NEWSLETTER SIGNUP* 🔔%0A%0A` +
      `━━━━━━━━━━━━━━━━━━━━━%0A` +
      `*Name:* ${formData.name}%0A` +
      `*Email:* ${formData.email}%0A` +
      `*Interests:* ${interestsList}%0A` +
      `*Date:* ${today}%0A` +
      `━━━━━━━━━━━━━━━━━━━━━%0A%0A` +
      `✅ _Data saved to Google Sheets_%0A` +
      `🔔 _Instant WhatsApp notification_`;
    
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`, '_blank');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ type: 'info', message: 'Submitting your information...' });

    try {
      setSubmitStatus({ type: 'info', message: 'Saving to Google Sheets...' });
      const googleResult = await submitToGoogleForms();
      
      if (googleResult.success) {
        setSubmitStatus({ type: 'success', message: '✓ Saved to Google Sheets' });
        
        setSubmitStatus({ type: 'info', message: 'Sending WhatsApp notification...' });
        sendWhatsAppNotification();
        
        setSubmitStatus({ type: 'success', message: '✓ WhatsApp notification sent!' });
        
        setTimeout(() => {
          setSubmitted(true);
        }, 1000);
      } else {
        setSubmitStatus({ 
          type: 'error', 
          message: 'Error saving to Google Sheets. Please try again.' 
        });
      }
    } catch (error) {
      setSubmitStatus({ 
        type: 'error', 
        message: 'An error occurred. Please try again.' 
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <PageContainer>
        <Container>
          <SuccessMessage>
            <FaCheckCircle />
            <h3>Thank You for Subscribing! 🎉</h3>
            <p>You've been successfully added to our newsletter list.</p>
            
            <div className="success-details">
              <h4><FaCheckCircle style={{ color: '#4CAF50' }} /> What happened:</h4>
              <ul>
                <li><FaCheckCircle /> Your information saved to Google Sheets (permanent storage)</li>
                <li><FaCheckCircle /> WhatsApp notification sent to our team</li>
                <li><FaCheckCircle /> You'll receive our next newsletter via email</li>
              </ul>
            </div>
            
            <p style={{ fontSize: '0.9rem', marginBottom: '2rem' }}>
              You'll receive our next newsletter with coding tips, course updates, and special offers.
            </p>
            
            <BackLink to="/">
              Return to Home <FaArrowRight />
            </BackLink>
          </SuccessMessage>
        </Container>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <Container>
        <LeftContent>
          <Title>
            Subscribe to Our <span>Newsletter</span>
          </Title>
          <Subtitle>
            Stay updated with the latest in medical coding, certification tips, 
            industry news, and exclusive offers from Learn Thru Us Academy.
          </Subtitle>

          <FeatureList>
            <FeatureItem>
              <FeatureIcon><FaBell /></FeatureIcon>
              <FeatureContent>
                <h3>Quarterly Updates</h3>
                <p>Get the latest coding guidelines and industry news every week</p>
              </FeatureContent>
            </FeatureItem>
            <FeatureItem>
              <FeatureIcon><FaCalendarAlt /></FeatureIcon>
              <FeatureContent>
                <h3>Exclusive Content</h3>
                <p>Access subscriber-only articles, tips, and resources</p>
              </FeatureContent>
            </FeatureItem>
            <FeatureItem>
              <FeatureIcon><FaChartLine /></FeatureIcon>
              <FeatureContent>
                <h3>Career Insights</h3>
                <p>Learn about job opportunities and career advancement</p>
              </FeatureContent>
            </FeatureItem>
            <FeatureItem>
              <FeatureIcon><FaBookOpen /></FeatureIcon>
              <FeatureContent>
                <h3>Special Offers</h3>
                <p>Get notified about course discounts and promotions</p>
              </FeatureContent>
            </FeatureItem>
          </FeatureList>
        </LeftContent>

        <RightContent>
          <FormContainer>
            <FormTitle>Join Our Community</FormTitle>
            <FormSubtitle>Fill in your details to subscribe</FormSubtitle>

            {submitStatus.message && (
              <StatusMessage type={submitStatus.type}>
                {submitStatus.type === 'info' && 'ℹ️'}
                {submitStatus.type === 'success' && '✅'}
                {submitStatus.type === 'error' && '❌'}
                {submitStatus.message}
              </StatusMessage>
            )}

            <Form onSubmit={handleSubmit}>
              <FormGroup>
                <Label>Your Name *</Label>
                <Input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter your full name"
                  required
                  disabled={isSubmitting}
                />
              </FormGroup>

              <FormGroup>
                <Label>Email Address *</Label>
                <Input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  required
                  disabled={isSubmitting}
                />
              </FormGroup>

              <FormGroup>
                <Label>I'm interested in: (select all that apply)</Label>
                {interests.map((interest, index) => (
                  <CheckboxGroup key={index}>
                    <Checkbox
                      type="checkbox"
                      name="interests"
                      value={interest}
                      checked={formData.interests.includes(interest)}
                      onChange={handleChange}
                      id={`interest-${index}`}
                      disabled={isSubmitting}
                    />
                    <CheckboxLabel htmlFor={`interest-${index}`}>
                      {interest}
                    </CheckboxLabel>
                  </CheckboxGroup>
                ))}
              </FormGroup>

              <CheckboxGroup>
                <Checkbox
                  type="checkbox"
                  name="agreeTerms"
                  checked={formData.agreeTerms}
                  onChange={handleChange}
                  required
                  id="agreeTerms"
                  disabled={isSubmitting}
                />
                <CheckboxLabel htmlFor="agreeTerms">
                  I agree to receive newsletters and promotional emails. 
                </CheckboxLabel>
              </CheckboxGroup>

              <SubmitButton type="submit" disabled={isSubmitting}>
                {isSubmitting ? (
                  'Submitting...'
                ) : (
                  <>
                    <FaEnvelope /> Subscribe Now
                  </>
                )}
              </SubmitButton>
            </Form>
          </FormContainer>
        </RightContent>
      </Container>
    </PageContainer>
  );
};

export default Signup;